'use client'

import { type ReactNode } from 'react'
import Image from 'next/image'
import { StatusBar } from './StatusBar'
import { bezel, flowContent, frame, screen, statusBar, statusBarWrapper } from './PhoneFrame.css'

type PhoneFrameProps = {
  children: ReactNode
}

export function PhoneFrame({ children }: PhoneFrameProps) {
  return (
    <div className={frame}>
      <Image src="/images/iphone17-frame.png" alt="" width={680} height={1380} className={bezel} priority />
      <div className={screen}>
        <div className={statusBarWrapper}>
          <StatusBar className={statusBar} />
        </div>
        <div className={flowContent}>{children}</div>
      </div>
    </div>
  )
}
